import {TRANNSMISSION_TYPE_ID_MANUAL} from '../../ads.js'
import {
  getConfigFields,
  getEmptyFieldRule,
  getMaxLengthConstraint,
  getNotNullConstraint,
  getPatternConstraint,
  getRemoteFieldRule
} from '../fields.js'
import {
  formFieldIds,
  PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL,
  reversedTransmissionsDatalist
} from '../values.js'

const {
  makeId,
  modelId,
  bodyTypeDoorsId,
  fuelId,
  yearId,
  versionId,
  transmissionTypeId,
  kilometersId,
  plate,
  vehicleStatus
} = formFieldIds

const formC2bVehicleFieldsConfig = [
  getConfigFields[plate](),
  getConfigFields[makeId](),
  getConfigFields[modelId](),
  getConfigFields[bodyTypeDoorsId](),
  getConfigFields[fuelId]({customProps: {label: 'COMMON.FUEL_TYPE'}}),
  getConfigFields[yearId](),
  getConfigFields[versionId](),
  getConfigFields[transmissionTypeId]({
    customProps: {datalist: [...reversedTransmissionsDatalist], label: 'COMMON.TRANSMISSION_TYPE'}
  }),
  getConfigFields[kilometersId]({
    customProps: {
      constraints: [
        getNotNullConstraint({
          message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.NOTNULL'
        }),
        getMaxLengthConstraint({
          value: 7
        }),
        getPatternConstraint({
          message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.MIN',
          pattern: PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL
        })
      ],
      hint: 'PUBLISH_AD.FB.KMS.COCHES.HELP',
      label: 'COMMON.KMS_VEHICLE'
    }
  }),
  getConfigFields[vehicleStatus]()
]

const formC2bVehicleFieldsWithRemotePropertyOrder = [makeId, modelId, bodyTypeDoorsId, fuelId, yearId, versionId]

const getFormC2bVehicleRules = () => {
  const rules = {}

  formC2bVehicleFieldsWithRemotePropertyOrder.forEach((fieldId, fieldIdIndex) => {
    if (!fieldIdIndex) return
    const previousFields = formC2bVehicleFieldsWithRemotePropertyOrder.slice(0, fieldIdIndex)
    const fieldRules = previousFields.map((previousFieldId, previousFieldIdIndex) => {
      return previousFieldIdIndex === previousFields.length - 1
        ? getRemoteFieldRule({id: previousFieldId})
        : getEmptyFieldRule({id: previousFieldId})
    })
    rules[fieldId] = fieldRules
  })

  return rules
}

const formC2bVehicleInitialValues = {
  [plate]: '',
  [makeId]: '',
  [modelId]: '',
  [bodyTypeDoorsId]: '',
  [fuelId]: '',
  [yearId]: '',
  [versionId]: '',
  [transmissionTypeId]: TRANNSMISSION_TYPE_ID_MANUAL.toString(),
  [kilometersId]: '',
  [vehicleStatus]: ''
}

export const formC2bVehicleFormConfig = {
  fields: formC2bVehicleFieldsConfig,
  initialValues: formC2bVehicleInitialValues,
  remotes: formC2bVehicleFieldsWithRemotePropertyOrder,
  rules: getFormC2bVehicleRules()
}
